// extracted by mini-css-extract-plugin
module.exports = {"buttonMenu":"main-menu-nav_buttonMenu__C8p4M","burgerMenu":"main-menu-nav_burgerMenu__Qwppu","burger":"main-menu-nav_burger__BLJeB","open":"main-menu-nav_open__LwqlR"};